import { t } from "i18next";
import React from "react";
import { useDispatch } from "react-redux";
import { CasinoIconGameType } from "../../../common/types/Casino/CasinoIconGameType";
import { FavoritCasinoResponceType } from "../../../common/types/Casino/FavoritCasinoResponceType";
import { FavoritCasinoStateType } from "../../../common/types/Casino/FavoritCasinoStateType";
import { useTypeSelector } from "../../../hooks/useTypeSelector";
import { CasinoInfo } from "../../../services";
import { setFavoritsLocalDelete } from "../../../store/action/favorits/setFavoritsLocalDelete";
import { setFavoritsLocalSelect } from "../../../store/action/favorits/setFavoritsLocalSelect";
import { setFavoritsUser } from "../../../store/action/favorits/setFavoritsUser";
import { setModalLogin } from "../../../store/action/modals/setmodallogin";
import { setModalPopap } from "../../../store/action/modals/setmodalpopap";

import "./GameItem.scss";

interface IGameItem {
  item: CasinoIconGameType | FavoritCasinoStateType | FavoritCasinoResponceType;
  checkedGame: number;
  wrapperRef: React.MutableRefObject<null>;
  handleCheckItem: (item: number) => void;
  liveCasino?: boolean;
}
const GameItem = ({ item, checkedGame, handleCheckItem, liveCasino }: IGameItem) => {
  const role = useTypeSelector((data) => data.accountInfoReducer.role);
  const favoritsGamesUser = useTypeSelector(
    (data) => data.favoritsReducer.favoritCasinoUser
  );
  const favoritsGamesLocal = useTypeSelector(
    (data) => data.favoritsReducer.favoritCasinoLocal
  );
  const dispatch = useDispatch();
  const handleOpenDemo = () => {
    async function searchPlay() {
      const res = await CasinoInfo.casinoPlay(
        `/${item.game_provider.slug}/${item.slug}?currency=TRY&lang=en&platform=desktop&game_link=true`
      );
      const url = res.data.game_link;
      window.open(url, "_blank");
    }
    searchPlay();
  };
  const handleOpenPlay = () => {
    async function searchPlay() {
      const res = await CasinoInfo.casinoPlay(
        `/${item.game_provider.slug}/${item.slug}?currency=TRY&lang=en&platform=desktop&game_link=true`
      );
      const url = res.data.game_link;
      window.open(url, "_blank");
    }
    if (role === "player") {
      searchPlay();
    } else {
      dispatch(setModalPopap(true));
      dispatch(setModalLogin(true));
    }
  };
  const handleFavoriteUserSelect = () => {
    async function gandleSelectFavorit() {
      await CasinoInfo.setFavoritGame({
        game_id: item.id,
        type: 1,
      });
      const res = await CasinoInfo.favoritGames();
      dispatch(setFavoritsUser(res.data));
    }
    async function gandleRemoveFavorit() {
      await CasinoInfo.setFavoritGame({
        game_id: item.id,
        type: 0,
      });
      const res = await CasinoInfo.favoritGames();
      dispatch(setFavoritsUser(res.data));
    }
    favoritsGamesUser.some((obj) => obj.id === item.id)
      ? gandleRemoveFavorit()
      : gandleSelectFavorit();
  };
  const handleFavoriteLocalSelect = () => {
    async function gandleSelectFavorit() {
      dispatch(
        setFavoritsLocalSelect({
          id: item.id,
          slug: item.slug,
          original_name: item.original_name,
          is_demo_enabled: item.is_demo_enabled,
          game_provider: {
            slug: item.game_provider.slug,
          },
          banner: item.banner,
        })
      );
    }
    async function gandleRemoveFavorit() {
      dispatch(
        setFavoritsLocalDelete({
          id: item.id,
          slug: item.slug,
          original_name: item.original_name,
          is_demo_enabled: item.is_demo_enabled,
          game_provider: {
            slug: item.game_provider.slug,
          },
          banner: item.banner,
        })
      );
    }
    favoritsGamesLocal.some((obj) => obj.id === item.id)
      ? gandleRemoveFavorit()
      : gandleSelectFavorit();
  };
  return (
    <div
      className="casino-game-item-content"
      onClick={() => handleCheckItem(item.id)}
    >
      <div className="casino-game-item  " data-badge="">
        <img
          src={item.banner}
          className="casino-game-item-image-bc"
          alt="In the Rabbit Hole"
          title="In the Rabbit Hole"
          loading="eager"
        />
        {checkedGame === item.id ? (
          <div className="casino-game-item-block">
            <div className="casino-game-icons">
              <i className="casino-game-info-icon bc-i-info" />
            </div>
            <h3 className="casino-game-item-label-bc">{item.original_name}</h3>
            <div className="casino-game-buttons">
              <button
                className="btn a-color "
                type="button"
                title="Play"
                onClick={handleOpenPlay}
              >
                <span>{t("casino.Play")}</span>
              </button>
              {item.is_demo_enabled && !liveCasino ? (
                <button
                  className="btn a-outline "
                  type="button"
                  title="Demo"
                  onClick={handleOpenDemo}
                >
                  <span>{t("casino.Demo")}</span>
                </button>
              ) : null}
            </div>
          </div>
        ) : null}

        {role === "player" ? (
          <i
            className={`casino-game-item-fav-bc bc-i-favorite ${
              favoritsGamesUser.some((obj) => obj?.id === item?.id)
                ? "active"
                : "null"
            }`}
            onClick={handleFavoriteUserSelect}
          />
        ) : (
          <i
            className={`casino-game-item-fav-bc bc-i-favorite ${
              favoritsGamesLocal.some((obj) => obj?.id === item?.id)
                ? "active"
                : "null"
            }`}
            onClick={handleFavoriteLocalSelect}
          />
        )}
      </div>
    </div>
  );
};

export { GameItem };
